import { useMemo } from "react";
import { CommunityGrowthQuery } from "@/__generated__/graphql";
import { useQuery } from "@apollo/client";
import { COMMUNITY_GROWTH_TIME_SERIES } from "@/api/queries/communityGrowthTimeSeries";
import { ChartDataPoint } from "@/util/chartUtils";
import { YesNoEnum } from "@/__generated__/types";

export const useCommunityGrowthQuery = (
  cohortYear: number | undefined,
  orgId: string | undefined,
  startDate: string,
  endDate: string,
  offset = 0,
) => {
  const year = cohortYear || 0;

  const { data, loading, error } = useQuery(COMMUNITY_GROWTH_TIME_SERIES, {
    variables: {
      cohortYear: year - offset,
      orgId: orgId || "",
      startDate,
      endDate,
      inCommunity: YesNoEnum.Yes,
    },
    skip: !orgId || !cohortYear,
  });

  const chartData = useMemo(() => {
    if (data) {
      return processQueryResult(data, year - offset, offset);
    }
  }, [data, offset, year]);
  return { data: chartData, loading, error };
};

export const offsetYear = (date: string, offset: number) => {
  const match = date.match(/^(\d\d\d\d)-/);
  const year: number = match ? +match[1] : 0;
  return date.replace(/^(\d\d\d\d)/, `${year + offset}`);
};

export const processQueryResult = (
  data: CommunityGrowthQuery | undefined,
  cohortYear?: number,
  yearOffset = 0,
): ChartDataPoint[] | undefined => {
  if (data?.node?.__typename === "Organization") {
    return (
      data?.node?.studentListTimeSeries?.map((dataPoint) => {
        return {
          date: offsetYear(dataPoint.date, yearOffset),
          [cohortYear || 0]: dataPoint.value,
        };
      }) || []
    );
  }
};
